import { isPlanPreparing } from "./workBriefGuidedHelpers";

/**
 * Canonical customer-facing readiness. Do not treat citation-level `ready`
 * as freeze-ready, and do not treat engineering-plan generation as a
 * discovery blocker.
 */
export function projectCustomerReadiness(input = {}) {
  const planStatus = String(input.planStatus || "").toLowerCase();
  const planPreparing = isPlanPreparing(planStatus);
  const planFailed = ["failed", "rejected", "insufficient_evidence"].includes(planStatus);
  const hasRequestText = Boolean(String(input.hasRequestText || input.requestText || "").trim());
  const hasSourceArtifacts = Boolean(input.hasSourceArtifacts);
  const sourceProcessingComplete = input.sourceProcessingComplete !== false && !input.sourceProcessingBusy;
  const discoveryMayBegin =
    sourceProcessingComplete && (hasRequestText || hasSourceArtifacts || Boolean(input.workBriefId));
  const hasDraft = Boolean(input.hasDraft);
  const openQuestionCount = Number(input.openQuestionCount) || 0;
  const discoveryHasUnresolvedQuestions = hasDraft && openQuestionCount > 0;
  const policyMode = input.policyMode || "strict";
  const approvalAllowed = input.approvalAllowed;
  const citationReady = input.citationReady === true;
  const intentFreezeReady = policyMode === "strict" && approvalAllowed === true;
  const contractState = input.contractState || null;
  const intentFrozen =
    contractState === "product_approved" || contractState === "engineering_acknowledged";
  const engineeringAcknowledged =
    Boolean(input.hasEngAck) || contractState === "engineering_acknowledged";
  const engineeringHandoffReady = intentFrozen && !engineeringAcknowledged;
  const implementationEvidenceReviewable =
    engineeringAcknowledged && Boolean(input.hasDeliveryBranch);
  const acceptanceReviewDecidable =
    implementationEvidenceReviewable && Boolean(input.hasAcceptanceReview);

  return {
    sourceProcessingComplete,
    discoveryMayBegin,
    discoveryHasUnresolvedQuestions,
    intentFreezeReady,
    intentFrozen,
    engineeringHandoffReady,
    engineeringAcknowledged,
    implementationEvidenceReviewable,
    acceptanceReviewDecidable,
    planPreparing,
    planFailed,
    citationReady,
  };
}

export function freezeReadyLabel(readiness) {
  if (!readiness?.intentFreezeReady) {
    return "Not ready to freeze";
  }
  return "Ready to freeze";
}
